module.exports = __webpack_public_path__ + "img/home-logo.a076138b.png";